<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-button type="primary" icon="el-icon-edit" @click.native="handleAdd()">添加</el-button>
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input placeholder="字段名称" v-model="query.content" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable>
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>

            <el-table-column label="字段名称(中文)" align="center" prop="nameZh" />
            <el-table-column label="字段名称(英文)" align="center" prop="name" />
            <el-table-column label="字段类型" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.type==1">文本</span>
                    <span v-if="scope.row.type==2">滑动</span>
                    <span v-if="scope.row.type==3">下拉</span>
                    <span v-if="scope.row.type==4">复选</span>
                    <span v-if="scope.row.type==0">其他</span>
                </template>
            </el-table-column>
            <el-table-column label="数值单位" align="center" prop="unitName" />
            <el-table-column width="300" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleSee(scope.row.id)">查看
                    </el-button>
                    <el-button type="primary" size="mini" @click="handleedit(scope.row.id)">修改
                    </el-button>
                   <el-button type="danger" size="mini" @click="handleDel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div> -->
        <el-pagination class="pagination-container" background :page-size="query.pageSize"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>

        <!--增加-->
        <el-dialog :visible.sync="formInput" :before-close="hideFormAdd" width="800px" top="5vh"
            :close-on-click-modal="false">
            <el-form :model="formData" :rules="formRules" ref="addForm" label-width="150px">
                <el-form-item label="字段名称-中文:" prop="nameZh">
                    <el-input v-model="formData.nameZh" clearable></el-input>
                </el-form-item>
                <el-form-item label="字段名称-英文:" prop="name">
                    <el-input v-model="formData.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="字段类型:" prop="type">
                    <el-select placeholder="请选择" v-model="formData.type">
                        <el-option label="文本" value="1"></el-option>
                        <el-option label="滑动" value="2"></el-option>
                        <el-option label="下拉" value="3"></el-option>
                        <el-option label="复选" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数值单位:">
                    <el-input v-model="formData.unitName" maxlength="8" clearable></el-input>
                </el-form-item>
                <el-form-item label="值:" prop="val" v-if="formData.type==3||formData.type==4">
                    <el-input style="width:200px;margin-right: 15px;" v-model="unitvalue"></el-input>
                    <el-button size="mini" type="primary" @click="addunit('add')">添加</el-button>
                    <div class="mt">
                        <el-tag class="tagStyle" v-for="(item,index) in formData.subValList" :key="index"
                            closable @close="removeunit(index)">
                            {{item}}
                        </el-tag>
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideFormAdd">取消</el-button>
                <el-button type="primary" @click="addsubmit()" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>

        <!--修改-->
        <el-dialog :visible.sync="formVisible" :before-close="hideForm" width="800px" top="5vh"
            :close-on-click-modal="false">
            <el-form :model="editformData" :rules="formRules" ref="dataForm" label-width="150px">
                <el-form-item label="字段名称-中文:" prop="nameZh">
                    <el-input v-model="editformData.nameZh" clearable></el-input>
                </el-form-item>
                <el-form-item label="字段名称-英文:" prop="name">
                    <el-input v-model="editformData.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="字段类型:" prop="type">
                    <el-select placeholder="请选择" v-model="editformData.type">
                        <el-option label="文本" value="1"></el-option>
                        <el-option label="滑动" value="2"></el-option>
                        <el-option label="下拉" value="3"></el-option>
                        <el-option label="复选" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数值单位:">
                    <el-input v-model="editformData.unitName" clearable></el-input>
                </el-form-item>
                <el-form-item label="值:" prop="val" v-if="editformData.type==3||editformData.type==4">
                    <el-input style="width:200px;margin-right: 15px;" v-model="unitvalue"></el-input>
                    <el-button size="mini" type="primary" @click="addunit('edit')">添加</el-button>
                    <div class="mt">
                        <el-tag class="tagStyle" v-for="(item,index) in editformData.list" :key="index" closable
                            @close="remove(index)">
                            {{item}}
                        </el-tag>
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>
        <!--  查看 --->
        <el-dialog title="查看" :visible.sync="formInfo" :before-close="hideInfo" width="800px" top="5vh"
            :close-on-click-modal="false">
            <el-form :model="infoData" label-width="150px">
                <el-form-item label="字段名称-中文:">
                    <span>{{infoData.nameZh}}</span>
                </el-form-item>
                <el-form-item label="字段名称-英文:">
                    <span>{{infoData.name}}</span>
                </el-form-item>
                <el-form-item label="字段类型:">
                    <span v-if="infoData.type==1">文本</span>
                    <span v-if="infoData.type==2">滑动</span>
                    <span v-if="infoData.type==3">下拉</span>
                    <span v-if="infoData.type==4">复选</span>
                    <span v-if="infoData.type==0">其他</span>
                </el-form-item>
                <el-form-item label="数值单位:">
                    <span>{{infoData.unitName}}</span>
                </el-form-item>
                <el-form-item label="值:">
                    <div style="display: flex; flex-direction: column;">
                        <span v-for="(item,index) in infoData.list" :key="index">
                            {{item.val}}
                        </span>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        SpecificationsList,
        specificationsDetail,
        specificationsUpdate,
        deleteSearchitem
    } from "../../api/product/classify.js";
    export default {
        data() {
            var checkTitle = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入中文名称"));
                } else {
                    callback();
                }
            };
            var checkTitle2 = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入英文名称"));
                } else {
                    callback();
                }
            };
            return {
                multipleSelection: [],
                cancelToggle: false,
                query: {
                    content: "",
                    currentPage: 1,
                    pageSize: 10
                },
                unitvalue: "",
                list: [],
                totalNumber: 0,
                loading: true,
                formLoading: false,
                formVisible: false,
                formInput: false,
                formInfo: false,
                formData: {
                    nameZh: "",
                    name: "",
                    type: "",
                    unitName: "",
                    subValList: []
                },
                editformData: {},
                infoData: {},
                formRules: {
                    nameZh: [{
                        required: true,
                        validator: checkTitle,
                        trigger: "blur"
                    }],
                    name: [{
                        required: true,
                        validator: checkTitle2,
                        trigger: "blur"
                    }],
                    type: [{
                        required: true,
                        message: "请选择字段类型",
                        trigger: "change"
                    }]
                }
            };
        },
        methods: {
            //选择
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            //取消选择
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            //重置
            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10,
                    content: ""
                };
                this.getList();
            },
            //查询
            onSubmit() {
                if (this.query.content == "") return
                this.query.currentPage = 1;
                this.query.pageSize = 10;
                this.getList();
            },
            //新增规格值
            addunit(type) {
                if (this.unitvalue == "") return
                if (type == 'add') {
                    this.formData.subValList.push(this.unitvalue)
                    this.unitvalue = ""
                }
                if (type == 'edit') {
                    this.editformData.list.push(this.unitvalue)
                    this.unitvalue = ""
                }
            },
            //删除规格值
            removeunit(index) {
                this.formData.subValList.splice(index, 1)
            },
            remove(index) {
                this.editformData.list.splice(index, 1)
            },
            //点击页码
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            //选择分页条数
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },
            regetlist() {
                this.query.currentPage = this.query.currentPage - 1
                this.getList();
            },
            getList() {
                this.loading = true;
                SpecificationsList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        if (this.query.currentPage > 1 && response.data.list.length < 1) {
                            this.regetlist();
                        } else {
                            this.list = response.data.list || [];
                            this.totalNumber = response.data.totalNumber || 0;
                            setTimeout(() => {
                                this.loading = false;
                            }, 0.3 * 1000);
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                this.$refs["dataForm"].resetFields();
            },
            //新增
            handleAdd() {
                this.formInput = true;
            },
            //取消添加
            hideFormAdd() {
                this.formInput = !this.formInput;
                this.$nextTick(() => {
                    this.$refs["addForm"].resetFields();
                });
                this.unitvalue = ""
            },
            // 修改
            handleedit(id) {
                //清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
                specificationsDetail({id: id}).then(res => {
                  this.formVisible = true
                  this.editformData = res.data
                  let list=[]
                  this.editformData.list.forEach(item=>{
                    list.push(item.val)
                  })
                  this.editformData.list=list
                });
            },
            //提交修改
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let pargram = this.editformData
                        if (pargram.type == 3 && pargram.list.length < 1) {
                            this.$message({
                                message: "请填写字段值",
                                type: "warning"
                            });
                            return
                        }
                        if (pargram.type == 4 && pargram.list.length < 1) {
                            this.$message({
                                message: "请填写字段值",
                                type: "warning"
                            });
                            return
                        }
                        this.formLoading = true;
                        let data = {
                            id: pargram.id,
                            subValList: pargram.list,
                            name: pargram.name,
                            nameZh: pargram.nameZh,
                            type: pargram.type,
                            unitName: pargram.unitName
                        };
                        specificationsUpdate(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            this.$refs["dataForm"].resetFields();
                            this.unitvalue = ""
                            this.formVisible = false;
                            this.getList();
                        });
                    }
                });
            },
            //添加按钮
            addsubmit() {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        let pargram = this.formData
                        if (pargram.type == 3 && pargram.subValList.length < 1) {
                            this.$message({
                                message: "请填写字段值",
                                type: "warning"
                            });
                            return
                        }
                        if (pargram.type == 4 && pargram.subValList.length < 1) {
                            this.$message({
                                message: "请填写字段值",
                                type: "warning"
                            });
                            return
                        }
                        let data = {
                            subValList: pargram.subValList,
                            name: pargram.name,
                            nameZh: pargram.nameZh,
                            type: pargram.type,
                            unitName: pargram.unitName
                        };
                        specificationsUpdate(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            this.$refs["addForm"].resetFields();
                            this.unitvalue = ""
                            this.formInput = false;
                            this.getList();
                        });
                    }
                });
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            console.log("ids=",ids);
                            deleteSearchitem({
                                    id: ids.toString()
                                })
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    this.getList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            },
            //查看
            handleSee(id) {
                specificationsDetail({id: id}).then(res => {
                  this.formInfo = true
                  this.infoData = res.data
                });
            },
            //关闭查看
            hideInfo() {
                this.formInfo = false
            }
        },
        created() {
            // 加载表格数据
            this.getList();
        }
    };

</script>

<style type="text/scss" lang="scss">
    body {
    margin: 0;
}
.app_logo {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.loading_div {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.productitem{
  display: flex;
  flex-direction: column;
  height: 200px;
  overflow-y: auto;
  width: 400px;
  border: 1px solid #DCDFE6;
  margin-bottom: 10px;
  padding-left: 15px;
}
.clecte{
  margin-left: 30px;
}
.mt {
        margin-top: 15px;
    }

    .tagStyle {
        margin-right: 10px;
        height: 32px;
        padding: 0 10px;
        line-height: 30px;
        margin-bottom: 5px;
    }
</style>
